/**
 * @flow
 * @relayHash 58abe9a500da27ad25e42780cb971d82
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GroupSearchableContractorDropdownQueryVariables = {|
  contractorName?: ?string,
  first?: ?number,
|};
export type GroupSearchableContractorDropdownQueryResponse = {|
  +contractorsByOrg: ?{|
    +edgeCount: ?number,
    +totalCount: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +fullName: ?string,
      |}
    |}>,
  |}
|};
export type GroupSearchableContractorDropdownQuery = {|
  variables: GroupSearchableContractorDropdownQueryVariables,
  response: GroupSearchableContractorDropdownQueryResponse,
|};
*/


/*
query GroupSearchableContractorDropdownQuery(
  $contractorName: String
  $first: Int
) {
  contractorsByOrg(contractorName: $contractorName, orderBy: "fullName", first: $first, excludeWithConflicts: true, includeInactive: false) {
    edgeCount
    totalCount
    edges {
      node {
        id
        fullName
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "contractorName",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "contractorsByOrg",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contractorName",
        "variableName": "contractorName"
      },
      {
        "kind": "Literal",
        "name": "excludeWithConflicts",
        "value": true
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Literal",
        "name": "includeInactive",
        "value": false
      },
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": "fullName"
      }
    ],
    "concreteType": "ContractorNodeConnection",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "edgeCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "totalCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractorNodeEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractorNode",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullName",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GroupSearchableContractorDropdownQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "GroupSearchableContractorDropdownQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "GroupSearchableContractorDropdownQuery",
    "id": null,
    "text": "query GroupSearchableContractorDropdownQuery(\n  $contractorName: String\n  $first: Int\n) {\n  contractorsByOrg(contractorName: $contractorName, orderBy: \"fullName\", first: $first, excludeWithConflicts: true, includeInactive: false) {\n    edgeCount\n    totalCount\n    edges {\n      node {\n        id\n        fullName\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '37ffac32573672a59958fbdc38494684';
module.exports = node;
